var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
var cls = classNames('slice-block-bubbles');
import { first } from 'lodash';
import { classNames } from '@shapeable/utils';
import { BlockImageContentGrid } from './block-image-content-grid';
import { EntityLinkButton } from './entity-link-button';
export var SliceBlockBubblesDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    img, \n    .gatsby-image-wrapper img {\n      width: 240px;\n      height: 240px;\n      object-fit: cover;\n      border-radius: 120px;\n    }\n\n    .shp--block-image-content__title {\n      text-transform: none;\n      font-size: 1.1em;\n      font-weight: 500;\n    }\n\n\n    .shp--content-entity-content {\n      li {\n        margin-bottom: 0.25em;\n        font-weight: 300;\n        &::before {\n          content: '+';\n          left: -0.2em;\n          font-size: 1em;\n          top: -0.1em;\n          position: relative;\n          color: ", ";\n        }\n      }\n    }\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    img, \n    .gatsby-image-wrapper img {\n      width: 240px;\n      height: 240px;\n      object-fit: cover;\n      border-radius: 120px;\n    }\n\n    .shp--block-image-content__title {\n      text-transform: none;\n      font-size: 1.1em;\n      font-weight: 500;\n    }\n\n\n    .shp--content-entity-content {\n      li {\n        margin-bottom: 0.25em;\n        font-weight: 300;\n        &::before {\n          content: '+';\n          left: -0.2em;\n          font-size: 1em;\n          top: -0.1em;\n          position: relative;\n          color: ", ";\n        }\n      }\n    }\n  "])), theme.COLOR('strong'))
});
var GridStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LinkStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: ", " 0;\n  "], ["\n    margin: ", " 0;\n  "])), theme.UNIT(8))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Grid: styled(BlockImageContentGrid)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  Link: styled(EntityLinkButton)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles)
};
export var SliceBlockBubbles = function (props) {
  var className = props.className,
    entity = props.entity;
  var _a = entity.blocks,
    blocks = _a === void 0 ? [] : _a,
    _b = entity.pages,
    pages = _b === void 0 ? [] : _b;
  var page = first(pages);
  return React.createElement(My.Container, {
    className: className
  }, React.createElement(My.Grid, {
    desktopLargeAutoColumns: 3,
    desktopFullHdAutoColumns: 3,
    desktopAutoColumns: 3,
    landscapeAutoColumns: 1,
    spacing: 8,
    items: blocks
  }), page && React.createElement(My.Link, {
    entity: page
  }));
};
SliceBlockBubbles.defaultProps = SliceBlockBubblesDefaultProps;
SliceBlockBubbles.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;